document.addEventListener('DOMContentLoaded', () => {
  // Navigation
  const header = document.querySelector('.header');
  const body = document.querySelector('body');
  const navToggle = document.querySelector('.mobile-nav-toggle');
  const primaryNav = document.querySelector('.primary-navigation');
  const menuIcon = document.querySelectorAll('.menu-icon');

  navToggle.addEventListener('click', () => {
    primaryNav.hasAttribute('data-visible')
      ? navToggle.setAttribute('aria-expanded', false)
      : navToggle.setAttribute('aria-expanded', true);
    primaryNav.toggleAttribute('data-visible');
    header.toggleAttribute('data-overlay');
    body.toggleAttribute('data-overlay');
  });

  menuIcon.forEach((el) => {
    el.addEventListener('click', () => {
      el.parentNode.toggleAttribute('data-visible');
    });
  });
});

jQuery(document).ready(function ($) {
  // var generateToc = function() {
  //   var sidebarInfo = $('.toc');
  //   var subtitles = $('h1, h2, h3')

  //   for(var i=0; i<subtitles.length; i++) {
  //     subtitles[i].setAttribute('id', `${subtitles[i].textContent.toLowerCase().replace(' ', '-')}`)
  //     sidebarInfo.append(`<a href="'#${subtitles[i].textContent.toLowerCase().replace(' ', '-')}' >${subtitles[i].textContent}</a>`);
  //   }
  // }

  // if($('article').hasClass('post-type-post')) {
  //   var sidebarInfo = $('.toc');
  //   var subtitles = $('h1, h2, h3')

  //   for(var i=0; i<subtitles.length; i++) {
  //     subtitles[i].setAttribute('id', `${subtitles[i].textContent.toLowerCase().replace(' ', '-')}`)
  //     sidebarInfo.append(`<a href="'#${subtitles[i].textContent.toLowerCase().replace(' ', '-')}' >${subtitles[i].textContent}</a>`);
  //   }
  // }

  //   // $(".widget-title").html(function(){
  //   //   var text= $(this).text().trim().split(" ");
  //   //   var first = text.shift();
  //   //   return (text.length > 0 ? "<span class='highlight'>"+ first + "</span> " : first) + text.join(" ");
  //   // });

  // $('.paragraph_image').each(function(){
  //   $el = $(this);
  //   var style = $el.attr('style');
  //   $el.attr('style','');
  //   $el.parent().attr('style',style);
  // }); //Moves the inline styles

  //Adds the dynamic captions for migrated posts
  $('.paragraph_image').each(function () {
    let title = this.title;
    $(this).after('<figcaption class="caption">' + title + '</figcaption>');
  });
});
